"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListCurrentAnswers = exports.getAnswerById = exports.findQuestionByIdInAllSections = exports.countAnsweredQuestions = exports.countTotalQuestions = exports.getAllQuestionKeys = exports.isLinkToParentSatisfied = exports.isAnswered = void 0;

var _lodash = require("lodash");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var isAnswered = function isAnswered(answer) {
  return !(0, _lodash.isEmpty)(answer) || (0, _lodash.isFinite)(answer) || (0, _lodash.isBoolean)(answer);
};

exports.isAnswered = isAnswered;

var isLinkToParentSatisfied = function isLinkToParentSatisfied(question, parentAnswer) {
  if (!question || !question.linkToParent || !isAnswered(parentAnswer)) {
    return false;
  }

  var _question$linkToParen = question.linkToParent,
      onlyFor = _question$linkToParen.onlyFor,
      anyExcept = _question$linkToParen.anyExcept;

  var equalsParentValue = function equalsParentValue(value) {
    return value === parentAnswer || Array.isArray(parentAnswer) && parentAnswer.includes(value);
  };

  return onlyFor != null && equalsParentValue(onlyFor) || anyExcept != null && !equalsParentValue(anyExcept);
};

exports.isLinkToParentSatisfied = isLinkToParentSatisfied;

var countQuestions = function countQuestions(getBaseValue, shouldCountSubQuestion, model) {
  var incrementForQuestion = function incrementForQuestion(question, questionKey) {
    if (!question) {
      return 0;
    }

    var increment = getBaseValue(questionKey);

    if (question.questions) {
      increment += Object.keys(question.questions).reduce(function (subQuestionsCount, subQuestionKey) {
        var subQuestion = question.questions[subQuestionKey];
        return shouldCountSubQuestion(subQuestion, questionKey, subQuestionKey) ? subQuestionsCount + 1 : subQuestionsCount;
      }, 0);
    }

    return increment;
  };

  return !(0, _lodash.isEmpty)(model.sections) ? Object.values(model.sections).reduce(function (totalCount, section) {
    return totalCount + Object.keys(section.questions).reduce(function (questionsCount, questionKey) {
      return questionsCount + incrementForQuestion(section.questions[questionKey], questionKey);
    }, 0);
  }, 0) : 0;
};

var getAllQuestionKeys = function getAllQuestionKeys(dataSource, model) {
  var shouldCountSubQuestion = function shouldCountSubQuestion(question, parentQuestionKey) {
    return dataSource && isLinkToParentSatisfied(question, dataSource[parentQuestionKey]);
  };

  var getKeysForQuestion = function getKeysForQuestion(question, questionKey) {
    var questionKeys = [];

    if (question && question.questions) {
      questionKeys = Object.keys(question.questions).reduce(function (subQuestionsKeys, subQuestionKey) {
        var subQuestion = question.questions[subQuestionKey];

        if (shouldCountSubQuestion(subQuestion, questionKey)) {
          subQuestionsKeys.push(subQuestionKey);
        }

        if (subQuestion && subQuestion.questions && !(0, _lodash.isEmpty)(subQuestion.questions)) {
          Object.keys(subQuestion.questions).forEach(function (subSubQuestionKey) {
            var subSubQuestion = subQuestion.questions[subSubQuestionKey];

            if (shouldCountSubQuestion(subSubQuestion, subQuestionKey)) {
              subQuestionsKeys.push(subSubQuestionKey);
            }
          });
        }

        return subQuestionsKeys;
      }, []);
    }

    return questionKeys;
  };

  if (!(0, _lodash.isEmpty)(model.sections)) {
    return (0, _lodash.flatten)(Object.values(model.sections).map(function (section) {
      return Object.keys(section.questions).reduce(function (sectionQuestionsKeys, questionKey) {
        sectionQuestionsKeys.push(questionKey);
        return (0, _lodash.concat)(sectionQuestionsKeys, getKeysForQuestion(section.questions[questionKey], questionKey));
      }, []);
    }));
  }

  return [];
};

exports.getAllQuestionKeys = getAllQuestionKeys;

var countTotalQuestions = function countTotalQuestions(dataSource, model) {
  var questionsNotCounted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return countQuestions(function () {
    return 1;
  }, function (question, parentQuestionKey, questionKey) {
    if (questionsNotCounted.indexOf(questionKey) !== -1) {
      return false;
    }

    return dataSource && isLinkToParentSatisfied(question, dataSource[parentQuestionKey]);
  }, model);
};

exports.countTotalQuestions = countTotalQuestions;

var countAnsweredQuestions = function countAnsweredQuestions() {
  var dataSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var model = arguments.length > 1 ? arguments[1] : undefined;
  var questionsNotCounted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return countQuestions(function (questionKey) {
    return dataSource && isAnswered(dataSource[questionKey]) ? 1 : 0;
  }, function (question, parentQuestionKey, questionKey) {
    if (questionsNotCounted.indexOf(questionKey) !== -1) {
      return false;
    }

    return dataSource && isLinkToParentSatisfied(question, dataSource[parentQuestionKey]) && isAnswered(dataSource[questionKey]);
  }, model);
};

exports.countAnsweredQuestions = countAnsweredQuestions;

var getQuestionById = function getQuestionById(questions, id) {
  for (var questionId in questions) {
    var question = questions[questionId];

    if (questionId === id) {
      return question;
    }

    if (question !== null && question !== void 0 && question.questions) {
      var subQuestions = question.questions;
      var res = getQuestionById(subQuestions, id);
      if (res) return res;
    }
  }
};

var findQuestionByIdInAllSections = function findQuestionByIdInAllSections(questionId, model) {
  if (!model || !(model !== null && model !== void 0 && model.sections)) return undefined;

  for (var sectionId in model.sections) {
    var section = model.sections[sectionId];
    return getQuestionById(section.questions, questionId);
  }
};

exports.findQuestionByIdInAllSections = findQuestionByIdInAllSections;

var getAnswerById = function getAnswerById(id, question) {
  if (question !== null && question !== void 0 && question.choices && question.choices.length > 0) {
    var _iterator = _createForOfIteratorHelper(question.choices),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var choice = _step.value;
        if (choice.value === id) return choice;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return undefined;
};

exports.getAnswerById = getAnswerById;

var getListCurrentAnswers = function getListCurrentAnswers(answers, model) {
  return Object.keys(answers).map(function (questionId) {
    var question = findQuestionByIdInAllSections(questionId.toString(), model);
    var answer = getAnswerById(answers[questionId], question);
    return {
      question: question.labelKey,
      answer: answer.labelKey,
      indent: Boolean((question === null || question === void 0 ? void 0 : question.linkToParent) && !(0, _lodash.isEmpty)(question.linkToParent))
    };
  });
};

exports.getListCurrentAnswers = getListCurrentAnswers;